import React from 'react';
import { Modal } from "react-bootstrap";
import '../beneficiary.css';
import { useDispatch } from 'react-redux';
import { setAbhaAddress, setBeneficiaryRedgOption, setTxnIdForAbhaAddress, updateChild } from '@store/actions/beneficiaryAction';
import abhaImg from '../../../assets/png/ABHA.png';
import aadharImg from '../../../assets/png/AADHAAR.png';
import { useNavigate } from 'react-router-dom';
import Phone from '../../../assets/svg_main/beneficiary/Phone number.svg';
import Temporary from '../../../assets/svg_main/beneficiary/Temporary Registartion.svg';
import FaceAuth from '../../../assets/svg_main/beneficiary/Face Authentication.svg';
import config from '@config/config';


interface showModalProps {
    showModal: boolean;
    handleClose: (option: string) => void;
    showTempRegistration?:boolean;
};


const BeneficiaryRedgeOptionModal = ({ showModal, handleClose,showTempRegistration=true }: showModalProps) => {
    const Navigate = useNavigate()
    const dispatch = useDispatch();
    const isFaceAuthEnabled = config.showFaceAuth === "ON";
    const handleOptionClick = (option: string) => {
        if (option === 'Temporary_Registration') {
            Navigate('/beneficiaries/temp')
        }
        dispatch(setBeneficiaryRedgOption(option))
        dispatch(setAbhaAddress(''));
        dispatch(setTxnIdForAbhaAddress(''))
        handleClose(option);

    };
    function handleBackClick(): void {
        handleClose('back');
    }

    function handleDiscardClick(): void {
        handleOptionClick('');
        dispatch(updateChild('isChildRegistration', false));
    }

    return (
        <>
            <div className="modal_Redg_Option_beneficiaries">
                <Modal
                    show={showModal}
                    onHide={() => handleOptionClick('')}
                    dialogClassName={'beneficiaries-option-card-modal'}
                    centered={true}
                    backdrop="static"
                >
                    <Modal.Header>
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "400px" }}>
                            <div className="d-flex align-items-center beneficiary_back_button" onClick={handleBackClick}>
                                <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                                <span className="ms-1">Back</span>
                            </div>
                            <div className="d-flex align-items-center beneficiary_discard_button" onClick={handleDiscardClick}>
                                <span className="me-0">Discard</span>
                                <i className="bi bi-x" ></i>
                            </div>

                        </div>
                    </Modal.Header>

                    <Modal.Body  >
                        <div className='option-container'>
                            <div className='abhaBlock' onClick={() => handleOptionClick('ABHA')}>
                                <img id='img' src={abhaImg} alt="ABHA Button" style={{ width: '60px', height: '40px' }} />
                                ABHA Number
                            </div>
                            <div className='other-option-block'>
                                <div className='option-box' onClick={() => handleOptionClick('Aadhaar')}>
                                    <img id='img' src={aadharImg} alt="ABHA Button" style={{ width: '60px', height: '40px' }} />
                                    Aadhaar Card
                                </div>
                                <div className='option-box' onClick={() => handleOptionClick('Phone_Number')}>
                                    <Phone />
                                    Phone Number
                                </div>
                                {isFaceAuthEnabled && <div className='option-box' onClick={() => handleOptionClick('Face_Authentication')}>                                    
                                    <FaceAuth />
                                    Face Authentication
                                </div>}
                               {showTempRegistration && <div className='option-box' onClick={() => handleOptionClick('Temporary_Registration')}>
                                    <Temporary />
                                    Temporary Registration
                                </div>}

                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
};

export default BeneficiaryRedgeOptionModal;